import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot
} from '@angular/router';
import { SubscriptionManagementService } from '@App/pages/pricing/services/subscription-management.service';
import { ProFeatureModalService } from '@Shared/services/pro-feature-modal.service';
import { of } from 'rxjs';
import { map, take, catchError } from 'rxjs/operators';
import { UserCommonApiService } from '@App/common/services';

@Injectable({ providedIn: 'root' })
class ProPlanValidation {
  constructor(
    private subscriptionManagementService: SubscriptionManagementService,
    private proFeatureModalService: ProFeatureModalService,
    private router: Router,
    private userCommonService: UserCommonApiService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.subscriptionManagementService.getCurrentPlan().pipe(
      take(1),
      map((plan) => {
        if (!plan) {
          if (this.userCommonService.isAuthenticated()) {
            this.proFeatureModalService.show();
          }
          this.router.navigate(['/']).then();
          return false;
        }
        const familyId = plan.access || plan.package || plan.familyId || '';
        const isPro = familyId.toLowerCase() === 'pro';
        const isProPlus = familyId.toLowerCase() === 'pro-plus';

        if (!isPro && !isProPlus) {
          if (this.userCommonService.isAuthenticated()) {
            this.proFeatureModalService.show();
          }
          this.router.navigate(['/']).then();
          return false;
        }

        return true;
      }),
      catchError(() => {
        if (this.userCommonService.isAuthenticated()) {
          this.proFeatureModalService.show();
        }
        this.router.navigate(['/']).then();
        return of(false);
      })
    );
  }
}

export const ProPlanValidationGuard: CanActivateFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  return inject(ProPlanValidation).canActivate(next, state);
};
